import { render, staticRenderFns } from "./menu-group.vue?vue&type=template&id=1eb6520e&"
import script from "./menu-group.vue?vue&type=script&lang=js&"
export * from "./menu-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb6520e')) {
      api.createRecord('1eb6520e', component.options)
    } else {
      api.reload('1eb6520e', component.options)
    }
    module.hot.accept("./menu-group.vue?vue&type=template&id=1eb6520e&", function () {
      api.rerender('1eb6520e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/menu/src/menu-group.vue"
export default component.exports